import { Store24HourIcon } from './Store24HourIcon';

/**
 * author: Google
 * id 417393DA-3C7F-4BF2-9283-AB1429FFA068
 * name store-24-hour
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-24-hour.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const LocalConvenienceStoreIcon = Store24HourIcon;
export default LocalConvenienceStoreIcon